<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3>个人书架</h3>
				</div>
				<div class="info-content" v-html="infoText">
				</div>
			</div>
		</div>
	</el-main>
</template>

<script>
	export default {
        data() {
            return {
                infoText: `
                   <p>“个人书架”是特规通为用户打造的专属知识空间与资料管理工具，面向工程技术人员“文件多、场景多、版本易变、反复查找耗时”的真实痛点，提供更高效的收藏、归类、检索与状态监控能力，帮助用户把平台海量资源转化为“随时可用、清晰可管、持续有效”的个人规范体系，从而显著提升日常工作与学习效率。</p><h3>1）两大默认书单：常用文件一键归集</h3><p>个人书架内置两个默认书单，帮助用户快速建立最常用的资料入口：</p><ul><li>收藏夹：针对平台收录的全部法规标准与相关资料，用户可一键加入收藏夹。无论是频繁使用的TSG、常查的国家标准，还是某个项目反复引用的条款文件，都能快速沉淀到自己的常用清单里，减少重复搜索时间。</li><li>已购买文件列表：用户在网上书城购买的纸质版、电子版文件会自动进入该书单，形成清晰的“个人资产清单”。打开书架即可快速查看已购资料，便于随时查阅与管理，也让采购与使用形成闭环。</li></ul><h3>2）自建书单：按场景与体系搭建“我的规范库”</h3><p>除了默认书单，个人书架支持用户自由创建自己的书单，按场景、设备种类、岗位职责、项目名称、工作环节等方式组织文件。例如可以建立“压力容器设计常用标准”“检验检测必备文件”“现场安装与验收”“企业合规审查清单”“培训学习书单”等多个列表，把分散的规范资料结构化整理成符合个人习惯的知识体系。对于跨项目、多岗位协作的用户，自建书单也能帮助快速切换工作上下文，让“找文件”变成“按清单直接用”。</p><p></p><p>同时，自建书单不仅是个人资料管理工具，也可直接与AI-行业大模型联动使用。用户在“个人书架”中创建好书单后，可在AI问答界面选择对应书单，系统将把当前问题的检索与回答范围限定在该书单所包含的文件之内。这样一来，用户既可以围绕某一项目、某一设备类型、某一专项工作建立专属资料集合，也可以在AI问答时让回答更聚焦于当前任务背景，减少无关内容干扰，提升检索效率与答案精准度。通过“书单管理+AI问答”的协同，个人书架进一步从“文件整理工具”升级为服务真实工作场景的个性化知识组织入口。</p><h3>3）书单内快速检索：在自己的范围内更快找到答案</h3><p>个人书架提供便捷的书单检索工具，支持在自己的书单范围内快速查找目标文件，避免在全库海量数据中反复筛选。尤其在项目推进、会议讨论、现场沟通等时间紧迫场景中，书单检索能大幅缩短定位时间，让关键依据随时可查。</p><h3>4）书架首页看板：资产与状态一目了然</h3><p>个人书架首页提供文件看板功能，集中展示用户书架内的文件数量、书单结构等关键概览信息，帮助用户快速了解自己的知识资产分布与使用情况。对企业用户或长期从业者而言，这种“可视化管理”能够把个人规范体系变得更清晰、更可维护，避免资料堆积无序导致的效率下降。</p><h3>5）效力状态提醒：版本变化及时可见，降低误用风险</h3><p>法规标准的更新频繁、实施状态变化多，是行业常见风险点。个人书架提供文件效力提醒能力：当书架内文件的实施状态发生变化（如修订、替代、废止等）时，将在书架主页进行提示，帮助用户及时关注版本更新与适用性变化，减少“引用旧版本、误用失效条款”的隐患，让规范使用更稳妥、更可靠。</p><h3>6）持续演进：更多知识管理能力持续完善</h3><p>个人书架将持续迭代，围绕“更好用的资料管理、更高效的学习沉淀、更安全的版本监控”不断扩展功能，为用户提供更多实用的知识管理工具，让每位从业者都能在特规通上建立起可复用、可成长的个人规范体系。</p><p></p><p>总体而言，“个人书架”不仅是一个收藏入口，更是一个帮助用户沉淀与管理专业知识资产的效率工具：把常用文件聚起来、按场景理清楚、在自己的范围内查得更快、对版本变化看得更及时，并可进一步作为AI问答的专属资料边界，让工作与学习都更轻松、更高效。</p>
                `
            }
        }
	};
</script>

<style lang="less" scoped>
	.info-wrap {
		margin-left: 20px;
		padding: 20px 0 !important;
		font-size: 14px;
		color: #475569;
		line-height: 1.8;
		background-color: #fff;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		border-radius: 12px;
		min-height: calc(100vh - 120px);
		h3 {
			margin: 0 0 10px;
			font-weight: 600;
			font-size: 24px;
			color: #334155;
		}
	}
	.info-item {
		margin-bottom: 20px;
	}
	.info-head {
		margin-bottom: 25px;
		padding-bottom: 15px;
		border-bottom: 1px dashed #e2e8f0;
		.topbox {
			color: #94a3b8;
			dd {
				margin: 0 30px 0 0;
			}
		}
	}
</style>

<style lang="less">
.info-content {
		padding: 0 30px;
		color: #0f172a;
	}

	.info-content h2 {
		margin: -4px 0 0 !important;
	}


	.info-content ul {
		li {
			line-height: 30px !important;
		}
	}

	.info-content p {
		margin-top: 6px !important;
		margin-bottom: 6px !important;
		line-height: 24px !important;
	}

	.info-content h3 {
		margin: 16px 0 6px !important;
	}

	.info-content h5 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		margin-top: 10px;
	}

	.info-content h6 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		position: relative;
	}

	.info-content h6:before {
		content: ' ';
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #155dfc;
		border-radius: 50%;
		margin-right: 10px;
		position: absolute;
		top: 16px;
		left: 18px;
	}

	.info-box {
		padding-bottom: 30px;
	}

	.info-content li::marker {
		color: #1456f0;
	}
</style>